import type { PropType } from 'virtual-vue';
import type { CellAlign, CellProps } from './cell';

export const DEFAULT_CELL_ALIGN = 'middle';

/**
 * 组件的props
 */
export const props = {
  /**
   * 右侧内容的垂直对齐方式
   * @default 'middle'
   */
  align: {
    type: String as PropType<CellAlign>,
    default: DEFAULT_CELL_ALIGN,
  },
  /**
   * 是否显示右侧箭头
   * @default false
   */
  arrow: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否显示下边框
   * @default true
   */
  bordered: {
    type: Boolean,
    default: true,
  },
  /**
   * 是否开启点击反馈
   * @default false
   */
  clickable: {
    type: Boolean,
    default: false,
  },
  /**
   * 标题下方内容描述
   */
  description: {
    type: String,
    default: '',
  },
  /**
   * 右侧说明文字下方的额外信息
   */
  extra: {
    type: String,
    default: '',
  },
  /**
   * 左侧图标，出现在单元格标题的左侧
   */
  leftIcon: {
    type: Object as PropType<CellProps['leftIcon']>,
  },
  /**
   * 和标题同行的说明文字
   */
  note: {
    type: String,
    default: '',
  },
  /**
   * 是否开启左右内边距
   * @default undefined
   * @description 如果未给值，则使用 cellGroup 的 padded 属性值
   */
  padded: {
    type: Boolean,
    default: undefined,
  },
  /**
   * 右侧图标，出现在单元格标题的右侧
   */
  rightIcon: {
    type: Object as PropType<CellProps['rightIcon']>,
  },
  /**
   * 标题
   */
  title: {
    type: String,
    default: '',
  },
  /**
   * 是否在 note 右侧展示重点提示小红点（位于右侧内容与 arrow / rightIcon 之间）
   * @default false
   */
  dot: {
    type: Boolean,
    default: false,
  },
};
